import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M5 0v24a2 2 0 01-2-2.005V2.005A2 2 0 014.995 0H5zm14.005 0A2 2 0 0121 2.005v19.99A2 2 0 0119.005 24H19V0h.005zM9 22v2H7v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2zm-6-6v2H7v-2h4zm6 0v2h-4v-2h4zm-4-6v2H7v-2h6zm4-4v2H7V6h10zM9 0v2H7V0h2zm4 0v2h-2V0h2zm4 0v2h-2V0h2z',
    ],
};
const IconReceipt = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconReceipt.displayName = 'IconReceipt';

export { IconReceipt };
//# sourceMappingURL=IconReceipt.js.map
